export default function getCsvContent({ data, columns }) {
	return [
		columns.map((col) => col[0]).join(","),
		...data.map((item, index) =>
			columns
				.map((col) => {
					const value = col[1](item, index);

					if (typeof value === "string" || typeof value === "number") {
						return parseValue(value);
					}

					if (Array.isArray(value)) {
						return parseValue(value.join(","));
					}

					return "";
				})
				.join(","),
		),
	].join("\n");
}

function parseValue(value) {
	const stringValue = String(value).replace(/"/g, '""');

	if (stringValue.includes(",") || stringValue.includes("\n") || stringValue.includes('"')) {
		return `"${stringValue}"`;
	}

	return stringValue;
}
